import { __assign } from "tslib";
export var defaultFeatureFlags = {
    wildcardValidDomainRuleDetection: true,
    extendedAppLoadTimeoutInMillis: undefined,
};
var currentFeatureFlagsState = defaultFeatureFlags;
export function getCurrentFeatureFlagsState() {
    return currentFeatureFlagsState;
}
export function setFeatureFlagsState(flags) {
    currentFeatureFlagsState = flags;
}
/**
 * Overwrite current featureFlags with any of the provided flags. The flags that weren't
 * provided in the input simply will be left as is. Updates the variable and also returns the updated result.
 * @param overwritingFlags The flags to overwrite the current featureFlags with.
 * @returns The updated featureFlags variable.
 */
export function overwriteFeatureFlagsState(overwritingFlags) {
    setFeatureFlagsState(__assign(__assign({}, currentFeatureFlagsState), overwritingFlags));
    return currentFeatureFlagsState;
}
//# sourceMappingURL=featureFlags.js.map